import { TkSearchFormListItem } from "../../type/componentsType/TkSearchForm";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";
import { TkGetCodeList } from "../../utils/TkGetCode";
import { GeneralFacilityType } from "../../assets/data/Constants";

const infoMessage: any = {
  1: (
    <div className="info">
      <span className="title">
        【４月１日までに新設した施設・事業がすべて登録されていることを確認してください。】
      </span>
      <br />
      登録されていない場合は、画面下部の「戻る」ボタンから「掛金納付対象職員届提出時の事前確認」画面に戻り、「確認１」で「いいえ」を選択し、新設した施設・事業を登録してください。
    </div>
  ),
  2: (
    <div className="info">
      <span className="title">
        【３月３１日までに廃止・休止した施設・事業の手続きが終わっていることを確認してください。】
      </span>
      <br />
      登録されていない場合は、画面下部の「戻る」ボタンから「掛金納付対象職員届提出時の事前確認」画面に戻り、「確認２」で「いいえ」を選択し、廃止・休止した施設・事業の手続きを完了してください。
    </div>
  ),
  3: (
    <div className="info">
      <span className="title">
        【各施設の名称、所在地、施設種類の登録情報を確認してください。】
      </span>
      <br />
      登録されていない場合は、画面下部の「戻る」ボタンから「掛金納付対象職員届提出時の事前確認」画面に戻り、「確認３」で「いいえ」を選択し、各施設の名称、所在地、施設種類を登録してください。
    </div>
  ),
  4: (
    <div className="info">
      <span className="title">
        【特定職員数又は措置入所障害児職員数を確認してください。】
      </span>
      <br />
      登録されていない場合は、画面下部の「戻る」ボタンから「掛金納付対象職員届提出時の事前確認」画面に戻り、「確認４」で「いいえ」を選択し、特定職員数又は措置入所障害児職員数を登録してください。
    </div>
  ),
};

/**
 * フォームの情報
 */

const facilityInfoHeadTitleList: any[] = [
  {
    headTitle: "施設名称",
    helpText: "現在登録されている施設等の名称です。",
  },
  {
    headTitle: "開設年月日",
    helpText:
      "施設区分が「社会福祉施設等」の場合は、事業開設年月日、「特定介護保険施設」、「申出施設等」の場合は申出日を表示しています。",
  },
  {
    headTitle: "施設住所",
    helpText: "現在登録されている施設等の所在地です。",
  },
  {
    headTitle: "施設種類",
  },
  {
    headTitle: "施設区分",
    helpText:
      "施設種類・サービス種類に応じた施設区分を表示しています。施設区分に応じて掛金が変わります。詳しくはこちら（別紙PDFへのリンク）をご確認ください。",
  },
  {
    headTitle: "特定職員数等",
    helpText:
      "「特定介護保険施設等」については、特定職員数または措置入所障害児関係業務従事職員数の人数分については、公費補助の対象となります。詳しくは、特定職員数はこちら（別紙PDFへのリンク）を、措置入所障害児関係業務従事職員数については、こちら（別紙PDFへのリンク）をご確認ください。",
  },
  {
    headTitle: "非加入届",
    helpText:
      "制度改正時点または施設の転換日時点で掛金が「単位掛金額×３」となる職員は加入させない手続きを行った施設・事業は「有」となっています。",
  },
  {
    headTitle: "部分解除",
    helpText:
      "制度改正以後または施設の転換日以後で掛金が「単位掛金額×３」となる職員を解除し、今後加入させない手続きを行った施設・事業は「有」となっています。",
  },
  {
    headTitle: "担当者情報",
    helpText:
      "施設情報や当該施設に係る加入職員について確認事項がある場合に、当機構より照会させていただく際の担当者様及び担当者様電話番号を表示しています。",
  },
];

/**
 * TkSearchFormのリスト
 */
const listData: TkSearchFormListItem[] = [
  {
    keyword: "type",
    label: "施設種類",
    type: "selectFrom",
    selectPropsList: TkGetCodeList(GeneralFacilityType),
  },
  {
    keyword: "name",
    label: "施設名",
    type: "label",
    inputProps: { maxLength: 20 },
  },
];

const schema = {
  name: {
    pattern: {
      value: /^[^ -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    minLength: {
      value: 0,
      message: TkPropertyMessageGet("TKMSG_SCR0045E", "0"),
    },
    maxLength: {
      value: 20,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "20"),
    },
  },
};

export { facilityInfoHeadTitleList, infoMessage, listData, schema };
